export const APPLICATION_ROOT = 'bsc-react-root';

export const MessageType = {
	KEEP_ALIVE: 'keepAlive'
};

export const Company = {
	System: 0,
	SuperTest: 7426
};
